export enum Screens {
  dashboardView = 'dashboard-view',
  schedulesView = 'schedules-view',
  schedulesStatusView = 'schedules-status-view',
  holidaysView = 'holidays-view',
  clientsView = 'clients-view',
  odontologyView = 'odontology-view',
  treatmentsView = 'treatments-view',
  modelsHealthCertificatesView = 'models-health-certificates-view',
  healthCertificatesView = 'health-certificates-view',
  modelsDocumentsView = 'models-documents-view',
  documentsView = 'documents-view',
  modelsFormsView = 'model-forms-view',
  formsView = 'forms-view',
  proceduresView = 'procedures-view',
  financialsPlansView = 'financials-plans-view',
  paymentsMethodsView = 'payments-methods-view',
  taxesView = 'taxes-view',
  movementsFinancialsView = 'movements-financials-view',
  financialsView = 'financials-view',
  guidesStatusView = 'guides-status-view',
  guidesView = 'guides-view',
  specialtiesView = 'specialties-view',
  terminologiesView = 'terminologies-view',
  professionalsView = 'professionals-view',
  covenantsView = 'covenants-view',
  usersView = 'users-view',
  accessGroupsView = 'access-groups-view',
  companyView = 'company-view',
  productsCategoriesView = 'products-categories-view',
  productsView = 'products-view',
  quickSaleView = 'quick-sale-view',
  salesView = 'sales-view',
  inventoriesView = 'inventories-view',
  cashRegisterView = 'cash-register-view',
  whatsAppView = 'whatsapp-view',
  whatsAppMonitoringView = 'whatsapp-monitoring-view',
  crmCampaignsView = 'crm-campaigns-view',
  crmTemplatesView = 'crm-templates-view',
  crmMessagingView = 'crm-messaging-view',
  crcDashboardView = 'crc-dashboard-view',
  crcContactsView = 'crc-contacts-view',
  crcPendenciesView = 'crc-pendencies-view',
  crcReportsView = 'crc-reports-view',
}
